import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { HuonekorttiStatusResponse } from "@/api/models/huonekortti-status-response"
import HuonekorttiStatusEnum from "@/types/HuonekorttiStatusEnum"
import { Loading } from "@element-plus/icons-vue"
import { computed } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComStatusTag',
  props: {
    status: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const typeMap: Record<HuonekorttiStatusResponse, string> = {
    [HuonekorttiStatusResponse.Tyo]: "info",
    [HuonekorttiStatusResponse.Julkaistu]: "primary",
    [HuonekorttiStatusResponse.Odottaa]: "warning",
    [HuonekorttiStatusResponse.Hyvaksytty]: "success"
}

const labelMap: Record<HuonekorttiStatusResponse, string> = {
    [HuonekorttiStatusResponse.Tyo]: HuonekorttiStatusEnum.Tyo,
    [HuonekorttiStatusResponse.Julkaistu]: HuonekorttiStatusEnum.Julkaistu,
    [HuonekorttiStatusResponse.Odottaa]: HuonekorttiStatusEnum.Odottaa,
    [HuonekorttiStatusResponse.Hyvaksytty]: HuonekorttiStatusEnum.Hyvaksytty
}

const type = computed(() => typeMap[props.status] ?? "primary")
const label = computed(() => labelMap[props.status] ?? "")

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(_component_el_tag, { type: type.value }, {
    default: _withCtx(() => [
      (__props.loading)
        ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            class: "is-loading",
            style: {"margin-right":"4px","vertical-align":"middle"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Loading))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(label.value), 1)
    ]),
    _: 1
  }, 8, ["type"]))
}
}

})